<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-16 11:27:04
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-05-10 15:36:45
 * @Description: 主页
 * @FilePath: \gfmis-card-ppt\src\views\index.vue
-->
<template>
  <div class="home">
    <head-com class="headCom" :headObj="headObj" :isShowBack="false">
      <template #headSlot>
        <div class="publicExpressionBlock">
          <div class="expressionItem projectExpression" @click="handleMenu(1)">
            <img class="menuBg leftBg" src="@/assets/images/menu_subsidize.png" />
            <img class="logo" src="@/assets/images/palm.png" />
            <span>补贴项目公示</span>
          </div>
          <div class="expressionItem publicExpression" @click="handleMenu(2)">
            <img class="menuBg rightBg" src="@/assets/images/menu_issue.png" />
            <img class="logo renLogo" src="@/assets/images/farmer.png" />
            <span>发放信息公示</span>
          </div>
        </div>
      </template>
    </head-com>
    <home-page></home-page>
  </div>
</template>

<script>
import headCom from '@/components/headCom.vue';
import homePage from './homePage.vue';
import headerImg from '@/assets/images/header-bg.png';

export default {
  name: 'MainPage',
  data() {
    return {
      headerImg: headerImg,
      isShowMenu: true,
      titleIndex: 0,
      headObj: {},
      TITLE_MAP: {
        0: {
          cnTitleName: '补贴项目公示(全省)',
          enTitleName: 'SUBSIDY PROJECTS LIST'
        },
        1: {
          cnTitleName: '补贴项目公示',
          enTitleName: 'SUBSIDY PROJECTS LIST'
        },
        2: {
          cnTitleName: '发放信息公示',
          enTitleName: 'SUBSIDIES'
        },
      }
    };
  },
  components: { headCom, homePage },
  mounted() {
    this.headObj = {
      cnTitleName: '补贴项目公示(全省)',// this.$route.meta.titleObj.cnName,
      enTitleName: 'SUBSIDY PROJECTS LIST'// this.$route.meta.titleObj.enName,
    }
  },
  methods: {
    handleMenu(type) {
      const { mofDivCode } = this.$store.getters.getSubsidizeProject
      if (!mofDivCode) {
        return this.$message.info('请选择对应行政化区');
      }
      let path = type == 1 ? '/card-pu/subsidizeProject' : '/card-pu/notification';
      path = `${path}?mof_div_code=${mofDivCode}`;
      this.titleIndex = type;
      this.$router.push(path);
    },
    handleBack() {
      this.$router.back();
    }
  },
};
</script>
<style scoped lang="scss">
.home {
  // height: 100%;
  min-width: 1024px;
  display: flex;
  flex-direction: column;

  .head-root {
    background-color: white;
  }


  .rootBlock {
    padding: 0 100px;
  }
}

.publicExpressionBlock {
  width: 100%;
  line-height: 60px;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: -15%;

  .expressionItem {
    width: 370px;
    margin: 0 60px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    cursor: pointer;
    position: relative;

    .menuBg {
      width: 90%;
      position: absolute;
      z-index: 1;
    }

    .logo {
      width: 50px;
      height: 50px;
      margin: auto 0;
      margin-right: 40px;
      z-index: 2;
    }

    .renLogo {
      width: 50px;
      height: 50px;
    }

    span {
      font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
      font-weight: 700;
      font-style: normal;
      font-size: 24px;
      text-align: center;
      z-index: 2;
    }
  }

  .projectExpression {
    color: white;
  }

  .publicExpression {
    color: black;
  }
}

.rootBlock {
  background-color: #f5f5f5;
}
</style>
